import React from 'react'
import { Header } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router'
import { Color } from '../../../../Common/Color'
import ComputerAssistancePhone from './ComputerAssistancePhone'
import ComputerSearch from './ComputerSearch'

const styles = {
  header: {
    gap: '10px',
    display: 'flex',
    padding: '1.5em',
    backgroundColor: Color.white,
    color: Color.dark_blue,
    height: '150px',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  logo: {
    cursor: 'pointer',
    marginRight: '1em'
  },
  boxText: {
    width: '20em',
    lineHeight: '17px',
    fontSize: '1.1em',
    display: 'flex'
  },
  search: {
    paddingLeft: '1em',
    display: 'flex'
  },
  menu: {
    '--hover-color': Color.primary,
    '--hover-border-color': Color.primary,
    border: 'solid 2px',
    fontSize: '1.5em',
    borderRadius: '1.5em',
    padding: '0 0.8em 5px 0.8em'
  }
}

export default function ComputerPublicHeader ({ withSearch = false }) {
  const navigate = useNavigate()

  return (<>
    <Header className={'header'} style={styles.header}>
      <img onClick={() => navigate('/')} style={styles.logo} className="logo" src="/images/logo-lbm-blanc.svg" alt='Logo' width="200px" />
      <div style={styles.boxText} className='hide-lower-1300'>
        <img className='hide-lower-1300' src="/images/box-exterieur.png" title="Image de la Box Médicale extérieur" width="200px" style={{ marginRight: '1em' }}/>
        Cabinet médical de téléconsultation augmentée
      </div>
      {withSearch && <ComputerSearch />}
      <ComputerAssistancePhone fontSize={'2em'}/>
    </Header>
  </>
  )
}
